import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["data-page-title"]


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarItem',
  props: {
  icon: { type: String, default: '' },
  mobile: { type: Boolean, default: false },
  name: { type: String, default: 'name' },
  route: { type: String, default: '/' },
  collapse: { type: Boolean, default: false },
  className: { type: String, default: 'sidebar-item' },
  style: {
    type: Object,
    default: function () {
      return {};
    },
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
    id: __props.name.toLowerCase() + '_nav',
    to: __props.route,
    class: _normalizeClass([[__props.className, { collapsed: __props.collapse }, { mobile: __props.mobile }], "no-underline"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "material-icons",
        textContent: _toDisplayString(__props.icon)
      }, null, 8, _hoisted_1),
      _createElementVNode("p", { "data-page-title": __props.name }, _toDisplayString(__props.name), 9, _hoisted_2)
    ]),
    _: 1
  }, 8, ["id", "to", "class"])), [
    [
      _directive_tooltip,
      { value: __props.name, disabled: !__props.collapse },
      void 0,
      { right: true }
    ]
  ])
}
}

})